<div class="result-view">

  @if (tokenItems.length > 0) {
    <div class="tokens-bar">
      @for (item of tokenItems; track item.labelKey) {
        <span class="token-badge">
          <span class="token-label">{{ item.labelKey | translate }}</span>
          <span class="token-value">{{ item.value | number }}</span>
        </span>
      }
    </div>
  }

  @if (errorMessage) {
    <div class="result-error">{{ errorMessage }}</div>
  } @else if (isEmptyResult()) {
    <div class="result-empty">{{ 'RETRIEVERS.EXECUTE.EMPTY_RESULT' | translate }}</div>
  } @else {
    <div class="result-list">
      @for (entry of entries; track entry.key) {
        @if (entry.isGroup) {
          <div class="result-group">
            <div class="group-name">{{ entry.key }}</div>
            <div class="group-items">
              @for (element of entry.value; track $index) {
                <div class="group-element">
                  @for (field of objectEntries(element); track field.key) {
                    <div class="result-item">
                      <span class="item-label">{{ field.key }}:</span>
                      <span class="val-text">{{ formatValue(field.value) }}</span>
                    </div>
                  }
                </div>
              }
              @if (entry.value.length === 0) {
                <div class="group-empty">—</div>
              }
            </div>
          </div>
        } @else {
          <div class="result-item-standalone">
            <span class="item-label">{{ entry.key }}:</span>
            <span class="val-text">{{ formatValue(entry.value) }}</span>
          </div>
        }
      }
    </div>
  }
</div>
